<div class="subBlockContainer" id="createtenant">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div class="inner-subBlock-wrapper">
        <div [formGroup]="userFormGroup" >
          <div class="container" formGroupName="userGroup">
            <label class="title">Partner Details</label>
            <!-- org section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="Organization Name"
                    required>
                </mat-form-field>
                <div class="col">
                </div>
                <!-- <mat-form-field [floatLabel]="'always'" class="col">
                  <mat-select placeholder="Market Segment" class="marketSegmentValidate" formControlName="marketSegmentField" multiple required>
                    <mat-option value="COM">
                      COMMERCIAL
                    </mat-option>
                    <mat-option value="EDU">
                      EDUCATION
                    </mat-option>
                    <mat-option value="GOV">
                      GOVERNMENT
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                <!-- <ng-select 
                  class="col customDropdwon"
                  [multiple]="true"
                  [items]="marketSegments"
                  [searchFn]="msStartsWithSearchFn"
                  bindValue="value"
                  bindLabel="display"
                  placeholder="Market Segment"
                  formControlName="marketSegmentField"
                  required
                >
                </ng-select> -->
              </div>
            </div>
            
            <!-- address section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput id = "addressLine1" class="addressLine1Validate" formControlName="addressLine1Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 1" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput id = "addressLine2" class="addressLine1Validate" formControlName="addressLine2Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 2">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput id = "addressLine3" class="addressLine1Validate" formControlName="addressLine3Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 3">
                </mat-form-field>

                <mat-form-field [floatLabel]="'always'" class="col">
                  <mat-select class="stateValidate" placeholder="State" formControlName="stateField" required>
                      <mat-option *ngFor="let s of stateList" [value]="s">
                          {{s}}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger"
                    (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="suburbField"
                    placeholder="Suburb" (keydown.Tab)="chooseAutoCompletSuburb($event)" (suburb)="startFilterSub($event)" 
                    required>
                  <mat-autocomplete #autoSuburb="matAutocomplete">
                    <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="postcodeValidate" #myAutocompleteTriggerPostcode="matAutocompleteTrigger"
                    (input)="onInputPostcode($event)" maxlength="4" (keypress)="isNumberKey($event)"
                    formControlName="postcodeField" (postcode)="startFilterPostcode($event)"
                    (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                    placeholder="Postcode" required>
                  <mat-autocomplete #autoPostcode="matAutocomplete">
                    <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <label class="title">Contact Details</label>
            <!-- contact section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="First Name"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="Last Name" required>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="emailValidate" formControlName="emailField" placeholder="Email Address" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField"
                    placeholder="Phone" required>
                </mat-form-field>
              </div>
            </div>

            <div style="padding-left: 15px;">
              <div>
                <mat-checkbox  formControlName="TandCAccecpted">
                  <span>
                    I, being duly authorized to act on behalf of my company, have read, understood, and hereby accept these
                     <strong fr-original-style="" (click)="downloadTermsPDFFile($event)" style="font-weight: 700; box-sizing: border-box; text-decoration: underline; cursor: pointer;">
                        &nbsp;VIP Marketplace Terms and Conditions
                    </strong>
                  </span>
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>       
        <div class="button-center">
          <button class="button button-red button-large" *ngIf="tenantId == ''" [disabled]="!userFormGroup?.get('userGroup.TandCAccecpted')?.value" (click)="saveEndUser()">Create</button>
          <loading-screen *ngIf="loadContent" [isChildLoader]="true" [showBlurTable]="false"></loading-screen>
        </div>
        
      </div>      
    </div>
   
  </div>
</div>
